import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { login_action, forgetCheckedEmail_action, forgetGetOtp_action, forgetUpdatePassword_action, get_login_pass_action, forgetChecked_action } from '../../actions/user_login_auth_actions/user_login_auth_action';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError, countryIWithCodeActionId } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator, loginPasswordValidator, otpValidator, confirmPasswordValidator } from '../../utils/Validator'
import Modal from "react-modal";
import Footerlogin from '../../common_components/Footerlogin';
import AdminHeader from '../../common_components/admin_module_header';
import { fill_action } from '../../actions/fillCombo_action'

/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/

// const mapStateToProps = state => {
//   return {
//     loginData: state,
//   };
// }


class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userEmail: '',
      password: '',
      is_showpass: false,
      isOpen: false,
      email: '',
      is_forgotPassword: false,
      isLoading: false,
      is_rememberme: false,
      verifyEmail: '',
      is_verifyEmail: false,
      is_loginForgotPassword: false,
      getOtp: '',
      forgetNewPass: '',
      forgetConfirmPass: '',
      exhCode: '',
      ExhibitionId: '',
      agentCode: '',

      isExibitionClosed: false,
      isregistrationLinkClosed: false,
      invalidLink: false,
    }
    this.handleObscure = this.handleObscure.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getLoginPass = this.getLoginPass.bind(this)
    this.getFillList = this.getFillList.bind(this)
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })
      this.props
        .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
        .then((data) => {
          if (data && data.error != 1) {
            // ExhibitionID
            if (actionID === countryIWithCodeActionId) {
              if (data.data && data.data.length > 0) {
                console.log("country data", data.data[0])
                this.setState({
                  isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                  isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                  isLoading: false,
                  ExhibitionID: data.data[0]['ExhibitionID']
                })
                resolve(data.data[0]['ExhibitionID'])
              } else {
                this.setState({ isLoading: false, invalidLink: true })
                resolve(null)
              }
            } else {
              this.setState({ isLoading: false })
              resolve(data)
            }
          } else {
            this.setState({ isLoading: false })
            if (data && data.msg) toastError(data.msg)
            resolve(null)
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ isLoading: false });
          resolve(null);
        });
    })
  }


  handleSubmit(isIndirectAccess) {
    // event.preventDefault();
    const { userEmail, password, exhCode, ExhibitionId } = this.state
    // this.props.navigate("/dashboard");
    console.log("testing-------------->", userEmail, password)
    //var errMsg = emailValidator(userEmail)
    var errMsg2 = loginPasswordValidator(password)
    // if (errMsg != '' || errMsg2 != '') {
    if (errMsg2 != '') {
      // toast.error(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : '', {
      toast.error(errMsg2 != '' ? errMsg2 : '', {
        theme: 'colored',
        autoClose: 1000,
        hideProgressBar: true,
      })
    } else {
      if (userEmail != ' ' && password != ' ') {
        this.setState({ isLoading: true })
        this.props
          .login_action(userEmail.toString().trim(), password.toString().trim())
          .then((data) => {
            if (data.error != 1) {
              // const dummyData = {
              //   // Dummy Data
              //   accessRights: [
              //     { ModuleId: "1", ModuleName: "Receipt", isUpdate: false, isAdd: true, isDelete: false, isView: true },
              //     { ModuleId: "2", ModuleName: "Agent", isUpdate: false, isAdd: true, isDelete: false, isView: true }
              //   ]
              // }
              // sessionStorage.setItem('DummyLoginData', JSON.stringify(dummyData))
              sessionStorage.clear()
              if (data.data['RoleID'] == 4 || data.data['RoleID'] == 1) {
                sessionStorage.setItem('IsAgentDirectLogin', true)
              }
              if (isIndirectAccess) {
                sessionStorage.setItem('isIndirectAccess', true)
              } else {
                sessionStorage.setItem('isIndirectAccess', false)
              }
              // sessionStorage.setItem("IsDirect", true)
              // sessionStorage.setItem("IsInDirect", false)
              sessionStorage.setItem("userEmailSS", userEmail)
              sessionStorage.setItem("tokenSS", "token")
              sessionStorage.setItem("AccountIDSS", data.data['AccountID'])
              sessionStorage.setItem("WorkOrderID", data.data['WorkOrderID'])
              const WorkOrderIDs = data.data.WorkOrderIDs
                .map(item => item.WorkOrderID)
                .join(',');
              sessionStorage.setItem("WorkOrderIDs", WorkOrderIDs)
              sessionStorage.setItem("loginDataSS", JSON.stringify(data.data))
              console.log("login data", data.data['FirstName'].charAt(0))
              console.log("login data", data.data['LastName'].charAt(0))
              sessionStorage.setItem("firstNameSS", data.data['FirstName'])
              sessionStorage.setItem("lastNameSS", data.data['LastName'])
              sessionStorage.setItem("profileNameSS", `${data.data['FirstName'].charAt(0)}${data.data['LastName'].charAt(0)}`)
              sessionStorage.setItem("RoleIDSS", data.data['RoleID'])
              sessionStorage.setItem("CurrentDateSS", data.data['CurrentDate'])
              if (password.includes('CSR')) {
                this.props.navigate("/changePassword", { state: { is_forgotPassword: true } });
              }
              else {
                if (exhCode != null && exhCode != '') {
                  this.getFillList(countryIWithCodeActionId, '', '', '', exhCode, '').then((exhid) => {
                    this.props.navigate("/selectExhibition", { state: { ExhibitionID: exhid } });
                  })
                }
                else if (ExhibitionId != '' && ExhibitionId != null) {
                  this.props.navigate("/selectExhibition", { state: { ExhibitionID: ExhibitionId } });
                }
                else {
                  this.props.navigate("/selectExhibition");
                }
              }

              this.setState({ isLoading: false })
            }
            else {
              this.setState({ isLoading: false })
              toast.error(data.msg, {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
              })
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      else {
        this.setState({ isLoading: false })

        toast.error('Please check user name and password', {
          theme: 'colored',
          autoClose: 1000,
          hideProgressBar: true,
        })
      }
    }
  }

  componentDidMount() {
    clearSessionStorage('')
    console.log('pathname : ', this.props.location.pathname);
    if (this.props.location.state != null && this.props.location.state != '' && this.props.location.state != undefined) {
      if (this.props.location.state.ExhibitionID != null && this.props.location.state.ExhibitionID != '' && this.props.location.state.ExhibitionID != undefined) {
        this.setState({
          ExhibitionID: this.props.location.state.ExhibitionID
        })
      }
    }
    if (this.props.location != null) {
      var url;
      if (this.props.location.pathname != null && this.props.location.pathname.includes('/login/')) {
        url = this.props.location.pathname != null && this.props.location.pathname.split("/login/")
      } else if (this.props.location.pathname != null) {
        url = this.props.location.pathname != null && this.props.location.pathname.split("/")
      }

      console.log('url : ', url);
      var loginContent = url[url.length - 1]
      console.log('loginContent : ', loginContent);
      var splitContent = loginContent != null && loginContent != "" && loginContent.split("--")
      console.log('splitContent : ', splitContent[0], splitContent[1], splitContent[2]);
      // var passwordContent = splitContent.length > 2 ? splitContent[2].replace('%C2%A7', '/') : splitContent[2]
      // console.log("content", splitContent[2])
      splitContent[0] != undefined && this.getFillList(countryIWithCodeActionId, '', '', '', splitContent[0], '')
      if (splitContent[1] != undefined) {
        this.getLoginPass(splitContent[0], splitContent[1].replace(/%C2%A7/g, '/')).then(res => {
          // this.getLoginPass(splitContent[0], splitContent[1]).then(res => {
          res && this.setState({
            userEmail: splitContent[1].replace(/%C2%A7/g, '/'),
            // userEmail: splitContent[1],
            password: res
          }, () => {
            if (loginContent != "" && loginContent != "login") {
              this.handleSubmit(true);
            }
          })
        })
      } else {
        if (splitContent[0] == undefined) {
          setTimeout(() => {
            this.props.navigate(`/login/ITME2026`)
            this.setState({
              exhCode: 'ITME2026'
            })
          }, 100);
        } else {
          if (splitContent[0].includes('-')) {
            // var splitList = urlCode.split('-');
            var index = splitContent[0].indexOf('-');
            var splitList = splitContent[0].split('-');
            // var splitList = urlCode.split('-').slice(1).join('-');
            console.log('agent code list : ', splitList, index);
            var exhCode = splitList.length > 0 ? splitList[0] : '';
            var agentCode = splitList.length > 1 ? splitList[1] : '';
            sessionStorage.setItem("agentCode", agentCode)
            // this.setState({ code: exhCode }, () => {
            setTimeout(() => {
              if (splitList[2] != '' && splitList[2] != null && splitList[2] != undefined) {
                this.props.navigate(`/countrySelect/${splitContent[0]}`)
              } else {
                toastError("Something went wrong...")
              }
            }, 100);
            // })
          } else {
            // exhCode = urlCode
            // sessionStorage.setItem("agentCode", '')
            this.setState({
              exhCode: splitContent[0]
            })
          }
        }
      }
    }

  }

  // forget login password

  getLoginPass(exhid, username) {
    return new Promise((resolve, reject) => {
      if (exhid != null && username != null && exhid != undefined && username != undefined) {
        this.props.get_login_pass_action(exhid, username)
          .then((data) => {
            if (data.error != 1) {
              console.log(data.data[0].Password)
              resolve(data.data[0].Password)
            } else {
              toastError(data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })

  }

  onVerifyEmail(e) {
    const { verifyEmail } = this.state
    // console.log("testing-------------->", verifyEmail)
    // var errMsg = ''
    var errMsg = emailValidator(verifyEmail)
    if (errMsg != '') {
      toast.error(errMsg != '' ? errMsg : '', {
        theme: 'colored',
        autoClose: 1000,
        hideProgressBar: true,
      })
    }
    else {
      if (verifyEmail != ' ') {
        this.setState({ isLoading: true })
        this.isCheckEmailPresent(e);
      }
    }
  }

  isCheckEmailPresent(e) {
    e.preventDefault()
    const { verifyEmail, isOpen, is_verifyEmail, } = this.state
    this.props
      .forgetCheckedEmail_action(verifyEmail)
      .then((data) => {
        if (data.error != 1) {
          toast.success('OTP Send on your Email', {
            theme: 'colored',
            autoClose: 3000,
            hideProgressBar: true,
          })
          console.log("FORG", data.data[0]['UserID'])
          sessionStorage.setItem("userIdForget", data.data[0]['UserID'])
          this.getOtp()
          this.setState({ is_verifyEmail: true })
          this.setState({ isLoading: false })
        }
        else {
          this.setState({ isLoading: false, email: '' })
          toast.error(data.msg, {
            theme: 'colored',
            autoClose: 3000,
            hideProgressBar: true,
          })
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getOtp() {
    const { verifyEmail } = this.state
    this.props
      .forgetGetOtp_action(verifyEmail)
      .then((data) => {
        if (data.error != 1) {
          // session
          this.setState({ isLoading: false })

        }
        else {
          this.setState({ isLoading: false, email: '' })
          toast.error(data.msg, {
            theme: 'colored',
            autoClose: 3000,
            hideProgressBar: true,
          })
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onVerifyOTP() {
    const { verifyEmail, getOtp } = this.state
    this.setState({ isLoading: true })
    this.props
      .forgetChecked_action(verifyEmail, getOtp)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, is_loginForgotPassword: true })

          toast.success("OTP Verify", {
            theme: 'colored',
            autoClose: 3000,
            hideProgressBar: true,
          })
        }
        else {
          this.setState({ isLoading: false, email: '' })
          toast.error(data.msg, {
            theme: 'colored',
            autoClose: 3000,
            hideProgressBar: true,
          })
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }


  onForgetPassword(e) {
    e.preventDefault();
    const { forgetNewPass, forgetConfirmPass, isOpen, is_forgotPassword } = this.state
    this.setState({ isLoading: true })
    // this.props.navigate("/dashboard");
    console.log("testing-------------->", forgetNewPass, forgetConfirmPass)
    var errMsg = loginPasswordValidator(forgetNewPass)
    var errMsg2 = confirmPasswordValidator(forgetNewPass, forgetConfirmPass)
    console.log(errMsg);
    console.log(errMsg2);
    if (errMsg != '' || errMsg2 != '') {
      toast.error(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : '', {
        theme: 'colored',
        autoClose: 1000,
        hideProgressBar: true,
      })
      this.setState({ isLoading: false })
    } else {
      if (forgetNewPass != '' && forgetConfirmPass != '') {
        this.props
          .forgetUpdatePassword_action(forgetConfirmPass)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false, isOpen: false })
              toast.success('Password Updated SuccessFully!', {
                theme: 'colored',
                autoClose: 1000,
                hideProgressBar: true,
              })
              // document.querySelector(".recovery").style.display = "none";
              this.clearValue()
              this.toggleModal()
            }
            else {
              this.setState({ isLoading: false, isOpen: !isOpen })
              toast.error(data.msg, {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
              })
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }

  }

  handleObscure() {
    const { is_showpass } = this.state
    this.setState({ is_showpass: !is_showpass })
  }

  //toggle model for forgot password.................................
  toggleModal() {
    const { isOpen, } = this.state
    this.setState({ isOpen: !isOpen })
    this.setState({
      verifyEmail: '',
      is_verifyEmail: false,
      is_loginForgotPassword: false,
      getOtp: ''
    })
  }


  handleKeyDown(e) {
    if (e.code === 'Enter') {
      this.onVerifyEmail(e)
    }
  }

  handleKeyDownOTP(e) {
    if (e.code === 'Enter') {
      this.onVerifyOTP(e)
    }
  }

  handleKeyDownForgotPass(e) {
    if (e.code === 'Enter') {
      this.onForgetPassword(e)
    }
  }


  render() {
    const { userEmail, password, invalidLink, isLoading, isOpen, isregistrationLinkClosed, verifyEmail, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword } = this.state
    return (
      <>

        {isLoading ? (
          <Loader></Loader>
        ) : (
          null
        )}
        <Modal isOpen={isOpen} onRequestClose={this.toggleModal}>
          <div className="modal-dialog custom_modal_dialog1">
            <div className="modal-content" style={{ marginTop: 110 }}>
              <div className="modal-body pl-0 pr-0">
                <div className="container">
                  <div className="row mt-4">
                    <img
                      src="images/6195699.png"
                      style={{ width: 110, margin: "0 auto" }}
                    />
                    <h3 className="text-center mb-1 mt-2">
                      <strong>Forgot Password</strong>
                    </h3>
                    <p className="text-center mb-4">
                      Please enter your registered email address to receive a password reset link.
                    </p>
                    <div className="col-xl-12 mt-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your register email id"
                        disabled={is_verifyEmail}
                        value={verifyEmail}
                        onChange={(e) => this.setState({ verifyEmail: e.target.value })}
                        onKeyDown={e => this.handleKeyDown(e)}
                      />
                    </div>
                    {!is_loginForgotPassword ?
                      <>
                        {is_verifyEmail ?
                          <div className="col-xl-12 mt-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter OTP"
                              value={getOtp}
                              maxLength={6}
                              onChange={(e) => this.setState({ getOtp: e.target.value })}
                              onKeyDown={e => this.handleKeyDownOTP(e)}
                            />
                          </div> :
                          <></>
                        }
                      </>
                      :
                      <>
                        <div className="col-xl-12 mt-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter New Password"
                            value={forgetNewPass}
                            onChange={(e) => this.setState({ forgetNewPass: e.target.value })}
                            onKeyDown={e => this.handleKeyDownForgotPass(e)}
                          />
                        </div>
                        <div className="col-xl-12 mt-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Confirm Password"
                            value={forgetConfirmPass}
                            onChange={(e) => this.setState({ forgetConfirmPass: e.target.value })}
                            onKeyDown={e => this.handleKeyDownForgotPass(e)}
                          />
                        </div>
                      </>
                    }
                  </div>

                  {
                    !is_verifyEmail ?

                      <button
                        className="btn mt-2 mb-1 btn-aqua w-100"
                        type="submit" onClick={(e) => this.onVerifyEmail(e)}
                      >
                        {" "}
                        Submit
                        {" "}
                      </button> :
                      <>
                        {!is_loginForgotPassword ?
                          <button
                            className="btn mt-2 mb-1 btn-aqua w-100"
                            type="submit" onClick={(e) => this.onVerifyOTP(e)}
                          >
                            {" "}
                            Submit
                            {" "}
                          </button> :
                          <button
                            className="btn mt-2 mb-1 btn-aqua w-100"
                            type="submit" onClick={(e) => this.onForgetPassword(e)}
                          >
                            {" "}
                            Submit
                            {" "}
                          </button>
                        }
                      </>
                  }
                  <a className="text-center text-aqua mt-2 d-block w-100" style={{ cursor: 'pointer' }} onClick={this.toggleModal}>
                    <i className="fa fa-angle-double-left" /> Back to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="modal-dialog custom_modal_dialog" >
            <div className="modal-content" style={{ borderRadius: '0px' }}>
              <div class="modal-header">
                <h4 class="modal-title modal_title_text">Forget Password</h4>
                <button type="button " class="close pop-close" data-dismiss="modal" onClick={this.toggleModal} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

              </div>
              <form>
                <div class="modal-body">
                  <div class="row">
                    <div className="form-group">
                      <label>Enter Email Id</label>
                      <input type="email"
                        className="form-control"
                        placeholder=""
                        value={email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                        onKeyDown={e => this.handleKeyDown(e)}
                        required />
                    </div>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-md-12">
                    <div class="form-group text-right mod-fot">
                      <button type='submit' class="btn  btn-Add rounded-0" onClick={(e) => this.forgetPassword(e)}><i class="fa fa-check"></i>&nbsp; Submit</button>
                      <button class="btn cancel_btn rounded-0" data-dismiss="modal"
                        style={{ marginLeft: '5px' }} onClick={this.toggleModal}><i class="fa fa-times"></i>&nbsp; No</button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div> */}
        </Modal>
        <ToastContainer />
        <AdminHeader isSteper={false} />
        <>

          <div
            className="container-fluid login-bg pt-0">
            {isregistrationLinkClosed ?
              <h5 className="text-center text-danger">Registration for this Exhibition is Closed</h5> :
              <h5 className="text-center pt-4 pb-0 text-dark">For new exhibitor Registration <a target='blank' style={{ cursor: 'pointer' }} className='header-login-a' onClick={() => !invalidLink ? this.props.navigate('/userRegistration', { state: { exhCode: this.state.exhCode } }) : toastError("The URL is Invalid. Please reach to ITME Support team for correct URL")}>click here</a></h5>}
            <div className="login-box" >

              <h4 className="login-name">User Login</h4>

              <div className="row mt-4">
                <div className="col-xl-12 mt-2">
                  <span className="text-sm text-muted text-center">
                    Welcome back! Kindly enter your details below.
                  </span>
                  <label className="text-left d-block mt-4">Email Id/Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email ID/Username"
                    value={userEmail}
                    onChange={(e) => this.setState({ userEmail: e.target.value })} 
                  />
                </div >
              </div >
              <div className="row">
                <div className="col-xl-12 ">
                  <label className="text-left d-block mt-3">Password</label>
                  <input
                    type={is_showpass ? "type" : "password"}
                    placeholder={is_forgotPassword ? "Enter password which got in an email" : "Enter Password"}
                    className="form-control"
                    value={password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                  <i
                    className="fa fa-eye show-password mt-2 mx-2"
                    onClick={this.handleObscure} />
                </div>
              </div>
              <button
                className="btn mt-4 mb-1 btn-aqua w-100"
                type="submit"
                onClick={() => !invalidLink ? this.handleSubmit(false) : toastError("The URL is Invalid. Please reach to ITME Support team for correct URL")}
              >
                {" "}
                <a
                  className="text-center text-white"
                  style={{ color: 'white' }}
                >
                  Login
                </a>{" "}
              </button>
              <div style={{ display: 'flex', justifyContent: 'end', marginTop: '5px' }}>
                <p className='mt-2'
                  style={{ cursor: 'pointer', color: '#dc3545', margin: 0 }}
                  onClick={() => !invalidLink ? this.toggleModal() : toastError("The URL is Invalid. Please reach to ITME Support team for correct URL")}
                >
                  Forgot Password?
                </p>

              </div>
              {
                // isregistrationLinkClosed ? (
                //   <h5 className="text-center text-danger">
                //     Registration for this Exhibition is Closed
                //   </h5>
                // ) : (
                //   <h5 className="registration-text text-center">
                //     For new registration{" "}
                //     <span
                //       className="registration-link header-login-a"
                //       onClick={() =>
                //         this.props.navigate("/userRegistration", {
                //           state: { exhCode: this.state.exhCode },
                //         })
                //       }
                //     >
                //       click here
                //     </span>
                //   </h5>
                // )
              }

            </div >
          </div >
        </>
        {/* <Footerlogin /> */}

      </>
    );
  }

}

export default withRouter(connect(null, { login_action, fill_action, forgetCheckedEmail_action, forgetGetOtp_action, get_login_pass_action, forgetUpdatePassword_action, forgetChecked_action })(Login));
